<script setup>
import { InformationCircleIcon } from "@heroicons/vue/24/solid";
import { formatNumber } from "@js/utils/formatter";
import { computed, h, ref } from "vue";
import { useTippy } from "vue-tippy";

const {
  number,
  align = "left",
  suffix,
  tooltipContent,
  color,
  withDecimals = false,
} = defineProps({
  number: {
    type: [Number, String],
    required: true,
  },
  align: {
    type: String,
    required: false,
  },
  suffix: {
    type: String,
    required: false,
  },
  tooltipContent: {
    type: String,
    required: false,
  },
  color: {
    type: String,
    required: false,
  },
  withDecimals: {
    type: Boolean,
    required: false,
  },
});

const tooltipButton = ref(null);

const innerTooltipContent = computed(() => {
  if (
    tooltipContent !== null &&
    tooltipContent !== "" &&
    typeof tooltipContent !== "undefined"
  ) {
    return h("div", {
      class:
        "max-h-[8rem] w-64 overflow-y-auto rounded bg-white px-2 py-1 drop-shadow wysiwyg",
      innerHTML: tooltipContent,
    });
  }

  return h("div");
});

useTippy(tooltipButton, {
  animation: "scale",
  placement: "right",
  interactive: true,
  interactiveBorder: 10,
  content: innerTooltipContent.value,
});
</script>

<template>
  <div
    class="flex h-full items-center whitespace-nowrap p-4 text-lg font-bold"
    :class="{
      'justify-start': align === 'left',
      'justify-center text-center': align === 'center',
      'justify-end': align === 'right',
      'text-green-500': color === 'green',
      'text-red-500': color === 'red',
    }"
  >
    {{ formatNumber(number, withDecimals) }}
    <template v-if="suffix">{{ suffix }}</template>

    <div
      v-if="
        tooltipContent !== null &&
        tooltipContent !== '' &&
        typeof tooltipContent !== 'undefined'
      "
      class="relative flex items-center justify-center pl-1"
    >
      <button ref="tooltipButton" type="button">
        <InformationCircleIcon class="size-5 cursor-help text-indigo-600" />
      </button>
    </div>
  </div>
</template>
